import { Localized } from "@fluent/react";
import { Download } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";

interface DownloadButtonProps {
    name?: string;
    value: string;
    disabled?: boolean;
}

export const DownloadButton: React.FC<DownloadButtonProps> = ({ name = "Document", value, disabled = false }) => {

    const handleDownloadClick = async () => {
        const element = document.createElement("a");
        const file = new Blob([value], { type: "text/plain" });
        element.href = URL.createObjectURL(file);
        element.download = `${name}.txt`;
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    };

    return (
        <Tooltip title={<Localized id="download">_Pobierz</Localized>}>
            <span>
                <IconButton disabled={disabled} onClick={() => handleDownloadClick()}>
                    <Download/>
                </IconButton>
            </span>
        </Tooltip>
    );
};
